import React from 'react';
import * as styles from './styles.css';
import { ROW_SOURCES } from './constants';
import { LazyImage } from '../LazyImage';
import { TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IAdPositionRowsProps {
  device: TDeviceType;
  setRowRef: (rowIndex: number) => (node: HTMLDivElement | null) => void;
}

export const AdPositionRows: React.FC<IAdPositionRowsProps> = ({ setRowRef, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      {ROW_SOURCES.map((src, rowIndex) => (
        <div key={rowIndex} ref={setRowRef(rowIndex)}>
          <LazyImage
            src={src}
            loaderColor="inverted"
            wrapperClassName={styles['row']}
            wrapperLoadingClassName={styles['loading-row']}
            alt=""
          />
        </div>
      ))}
    </div>
  );
};
